import React, { useState, useContext } from "react";
import { useMobile } from "../../hooks/isMobile.tsx";
import { Container, Link } from "../styled.ts";
import { Typography } from "../typography/index.tsx";
import { Hamburger } from "./hamburger.tsx";
import { MenuIcon } from "../icons/menu.tsx";
import { useHistory, Link as RouterLink } from "react-router-dom";
import { subscriberContext } from "../../context/subscriberContext.tsx";

export const LinksSection = ({ active = "home" }) => {
  const { isMobile } = useMobile();
  const history = useHistory();
  const [isOpen, setIsOpen] = useState(false);
  const [isProfileOpen, setIsProfileOpen] = useState(false);
  const { subscriberDetails, logout } = useContext(subscriberContext);

  const isSubscriberLogin = Boolean(subscriberDetails?.phoneNumber);

  const toggleOpen = () => {
    setIsOpen((open) => !open);
  };

  const toggleProfile = () => {
    setIsProfileOpen((open) => !open);
  };

  const handleLogout = () => {
    logout();
    if (history?.location) {
      history.push("/");
    } else {
      window.location.assign("/");
    }
  };

  const renderProfileMenu = () => {
    if (isMobile) {
      return (
        <>
          <Typography
            fontFamily="Neue Montreal"
            fontSize={isMobile ? "16px" : "18px"}
            fontWeight={isMobile ? 400 : 500}
            lineHeight={isMobile ? "17.92px" : "20.16px"}
            letterSpacing={"-0.01em"}
            color="#202020"
          >
            <Link as={RouterLink} active={active === "profile"} to="/profile">
              My Profile
            </Link>
          </Typography>
          <Typography
            fontFamily="Neue Montreal"
            fontSize={isMobile ? "16px" : "18px"}
            fontWeight={isMobile ? 400 : 500}
            lineHeight={isMobile ? "17.92px" : "20.16px"}
            letterSpacing={"-0.01em"}
            color="#202020"
          >
            <Link as={RouterLink} active={active === "notification-filters"} to="/notification-filters">
              Notification Filters
            </Link>
          </Typography>
          <Container
            as="button"
            style={{
              cursor: "pointer",
              opacity: 0.8,
              background: "none",
              border: "none",
              padding: 0,
              textAlign: "left",
            }}
            onClick={handleLogout}
          >
            <Typography
              fontFamily="Neue Montreal"
              fontSize={isMobile ? "16px" : "18px"}
              fontWeight={isMobile ? 400 : 500}
              lineHeight={isMobile ? "17.92px" : "20.16px"}
              letterSpacing={"-0.01em"}
              color="#202020"
            >
              <Link as="span" active>Logout</Link>
            </Typography>
          </Container>
        </>
      );
    }

    return (
      <Container
        padding="11px 20px"
        gap="10px"
        radius="100px"
        alignItems="center"
        background="#fff"
        style={{ position: "relative" }}
        onClick={toggleProfile}
      >
        <div style={{ cursor: "pointer", color: "#202020" }}>
          <MenuIcon />
        </div>
        {isProfileOpen && (
          <Container
            style={{
              position: "absolute",
              top: "100%",
              right: 0,
              background: "#fff",
              borderRadius: "8px",
              padding: "8px 0",
              marginTop: "8px",
              minWidth: "150px",
              boxShadow: "0 4px 12px rgba(0, 0, 0, 0.1)",
              display: "flex",
              flexDirection: "column",
            }}
          >
            <Container
              as={RouterLink}
              to="/profile"
              padding="8px 16px"
              style={{
                cursor: "pointer",
                borderBottom: "1px solid #f0f0f0",
                textDecoration: "none",
              }}
              onClick={(e) => e.stopPropagation()}
            >
              <Typography
                fontFamily="Neue Montreal"
                fontSize="16px"
                fontWeight={400}
                lineHeight="20px"
                color="#202020"
              >
                <Link as="span" active={active === 'profile'}>
                My Profile
                </Link>
              </Typography>
            </Container>
            <Container
              as={RouterLink}
              to="/notification-filters"
              padding="8px 16px"
              style={{
                cursor: "pointer",
                borderBottom: "1px solid #f0f0f0",
                textDecoration: "none",
              }}
              onClick={(e) => e.stopPropagation()}
            >
              <Typography
                fontFamily="Neue Montreal"
                fontSize="16px"
                fontWeight={400}
                lineHeight="20px"
                color="#202020"
              >
                <Link as="span" active={active === 'notification-filters'}>
                Notification Filters
                </Link>
              </Typography>
            </Container>
            <Container
              as="button"
              padding="8px 16px"
              style={{
                cursor: "pointer",
                background: "none",
                border: "none",
                width: "100%",
                textAlign: "left",
              }}
              onClick={(e) => {
                e.stopPropagation();
                handleLogout();
              }}
            >
              <Typography
                fontFamily="Neue Montreal"
                fontSize="16px"
                fontWeight={400}
                lineHeight="20px"
                color="#202020"
              >
                <Link as="span" active>Logout</Link>
              </Typography>
            </Container>
          </Container>
        )}
      </Container>
    );
  };

  return (
    <>
      {isMobile && <Hamburger isOpen={isOpen} toggleOpen={toggleOpen} />}
      {(!isMobile || (isMobile && isOpen)) && (
        <Container
          justifyContent="space-between"
          flex={0.6}
          column={isMobile}
          background={isMobile ? "#ffffff" : "transparent"}
          radius={"16px"}
          gap={isMobile ? "10px" : "0"}
          style={
            isMobile
              ? {
                  position: "absolute",
                  right: "20px",
                  top: "50px",
                  padding: "20px",
                  boxShadow: "0 2px 8px rgba(0, 0, 0, 0.1)",
                }
              : {}
          }
        >
          <Container
            gap={isMobile ? "10px" : "60px"}
            alignItems={isMobile ? "" : "center"}
            column={isMobile}
          >
            {!isSubscriberLogin && (
              <Typography
                fontFamily="Neue Montreal"
                fontSize={isMobile ? "16px" : "18px"}
                fontWeight={isMobile ? 400 : 500}
                lineHeight={isMobile ? "17.92px" : "20.16px"}
                letterSpacing={"-0.01em"}
                color="#202020"
              >
                <Link as={RouterLink} active={active === "home"} to="/" >
                  Home
                </Link>
              </Typography>
            )}
            {isSubscriberLogin && (
              <Typography
                fontFamily="Neue Montreal"
                fontSize={isMobile ? "16px" : "18px"}
                fontWeight={isMobile ? 400 : 500}
                lineHeight={isMobile ? "17.92px" : "20.16px"}
                letterSpacing={"-0.01em"}
                color="#202020"
              >
                <Link as={RouterLink} active={active === "watch-list"} to="/watch-list">
                  Watch List
                </Link>
              </Typography>
            )}
            <Typography
              fontFamily="Neue Montreal"
              fontSize={isMobile ? "16px" : "18px"}
              fontWeight={isMobile ? 400 : 500}
              lineHeight={isMobile ? "17.92px" : "20.16px"}
              letterSpacing={"-0.01em"}
              color="#202020"
            >
              <Link as={RouterLink} active={active === "news"} to="/news">
                FinQ Wrap
              </Link>
            </Typography>
            <Typography
              fontFamily="Neue Montreal"
              fontSize={isMobile ? "16px" : "18px"}
              fontWeight={isMobile ? 400 : 500}
              lineHeight={isMobile ? "17.92px" : "20.16px"}
              letterSpacing={"-0.01em"}
              color="#202020"
            >
              <Link
                as={RouterLink}
                active={active === "subscription-plans"}
                to="/subscription-plans"
              >
                Subscription Plans
              </Link>
            </Typography>
            {isMobile && isSubscriberLogin && renderProfileMenu()}
          </Container>
          {!isMobile && isSubscriberLogin && renderProfileMenu()}
        </Container>
      )}
    </>
  );
};
